import apiService from './apiService';

export const authService = {
    login: (credentials) => apiService.post('/auth/login', credentials),
    sso: (accessToken) => apiService.post('/auth/sso', { accessToken }),
    logout: () => apiService.post('/auth/logout'),
    forgotPassword: (email) => apiService.post('/auth/forgot-password', { email }),
    resetPassword: (token, newPassword, confirmPassword) => apiService.post('/auth/reset-password', { token, newPassword, confirmPassword }),
    changePassword: (currentPassword, newPassword, confirmPassword) => apiService.post('/auth/change-password', { currentPassword, newPassword, confirmPassword }),
    validateResetToken: (token) => apiService.get('/auth/validate-reset-token', { token }),
    accountStatus: (email) => apiService.get('/auth/account-status', { email }),
    passwordPolicy: () => apiService.get('/auth/password-policy'),
    me: () => apiService.get('/auth/me'),
    mfaVerify: (email, otp) => apiService.post('/auth/mfa/verify', { email, otp }),
    mfaResend: (email) => apiService.post('/auth/mfa/resend', { email }),
    mfaStatus: () => apiService.get('/auth/mfa/status'),
    mfaEmailEnable: () => apiService.post('/auth/mfa/email/enable'),
    mfaEmailEnableVerify: (otp) => apiService.post('/auth/mfa/email/enable/verify', { otp }),
    mfaSmsEnable: () => apiService.post('/auth/mfa/sms/enable'),
    mfaSmsEnableVerify: (otp) => apiService.post('/auth/mfa/sms/enable/verify', { otp }),
    mfaSmsDisable: () => apiService.post('/auth/mfa/sms/disable'),
    mfaSmsDisableVerify: (otp) => apiService.post('/auth/mfa/sms/disable/verify', { otp }),

    refreshToken: (refreshToken) => apiService.post('/auth/refresh', { refreshToken }),

    profile: {
        get: () => apiService.get('/profile/me'),
        update: (data) => apiService.put('/profile/me', data),
    },
};
